/* Keep storefront navigation in the document's language. */
(function () {
  'use strict';
  var language = document.documentElement.lang.toLowerCase().split('-')[0];
  if (language !== 'ja' && language !== 'en') return;
  function localizedURL(value) {
    if (!value || /^(#|mailto:|tel:|javascript:)/i.test(value)) return value;
    var url;
    try { url = new URL(value, location.href); } catch (_) { return value; }
    var shopAccount = url.hostname === 'shopify.com' && url.pathname === '/64803766500/account';
    var localAccount = url.origin === location.origin && /^\/(?:customer_authentication|account)(?:\/|$)/.test(url.pathname);
    if ((shopAccount || localAccount) && url.searchParams.has('locale')) {
      url.searchParams.set('locale', language);
      return shopAccount ? url.href : url.pathname + url.search + url.hash;
    }
    if (url.origin !== location.origin) return value;
    if (language === 'ja') {
      if (!/^\/en(?:\/|$)/.test(url.pathname)) return value;
      url.pathname = url.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    } else {
      if (!/^\/(?:$|(?:products|collections|blogs|pages|search|cart|policies|account)(?:\/|$))/.test(url.pathname)) return value;
      url.pathname = '/en' + url.pathname;
    }
    return url.pathname + url.search + url.hash;
  }
  function repair(root) {
    var elements = [];
    if (root.matches && root.matches('a[href],form[action],[data-url]')) elements.push(root);
    if (root.querySelectorAll) elements.push.apply(elements, root.querySelectorAll('a[href],form[action],[data-url]'));
    elements.forEach(function (el) {
      if (el.closest('.localization-form') || el.hasAttribute('hreflang') || el.hasAttribute('lang')) return;
      ['href', 'action', 'data-url'].forEach(function (attr) {
        if (!el.hasAttribute(attr)) return;
        var old = el.getAttribute(attr), next = localizedURL(old);
        if (old !== next) el.setAttribute(attr, next);
      });
    });
  }
  if (window.Shopify && Shopify.routes) Shopify.routes.root = language === 'en' ? '/en/' : '/';
  if (window.routes) Object.keys(window.routes).forEach(function (key) {
    if (typeof window.routes[key] === 'string') window.routes[key] = localizedURL(window.routes[key]);
  });
  repair(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') repair(record.target);
      else record.addedNodes.forEach(function (node) { if (node.nodeType === 1) repair(node); });
    });
  }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['href','action','data-url']});
})();
